import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

const photoIconClass = 'item-modal__photo-icon';

export const PhotoButton = ({ action, additionalClass }) => (
  <button
    type="button"
    className={cn(photoIconClass, `${photoIconClass}--${additionalClass}`)}
    onClick={action}
  />
);

PhotoButton.propTypes = {
  additionalClass: PropTypes.string,
  action: PropTypes.func.isRequired
};
